import styled from 'styled-components';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  padding-top: 35px;
  padding-left: 15px;
  padding-right: 15px;
`;

export const GoalContainer = styled.div`
  font-family: 'Avenir', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 1;
  color: #000;
  align-self: center;

  @media only screen and (min-width: 551px) {
    .dashboard-card {
      min-width: 500px !important;
    }
  }
`;

export const CardContainer = styled.div`

`;
